import { Component, OnInit } from '@angular/core'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import { UnespCoreMessageService } from '@unesp/core'
import { CertificadoService } from 'src/app/services/certificado.service'
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component'
import { MatDialog } from '@angular/material/dialog'
import { ReCaptchaV3Service } from 'ng-recaptcha-2'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-certificado-validador',
  templateUrl: './certificado-validador.component.html',
  styleUrls: ['./certificado-validador.component.css'],
  standalone: false
})
export class CertificadoValidadorComponent implements OnInit {
  form = new FormGroup({
    codigo: new FormControl('', Validators.required),
  })

  constructor(
    private unespCoreMessageService: UnespCoreMessageService,
    private certificadoService: CertificadoService,
    private dialog: MatDialog,
    private recaptchaV3Service: ReCaptchaV3Service,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.form.controls.codigo.setValue(params['codigo'])
    })
  }

  applyTouchedToInvalidFields() {
    for (const name in this.form.controls) {
      if (this.form.get(name)?.invalid) {
        this.form.get(name)?.markAsTouched()
      }
    }
  }

  verificar(): void {
    this.applyTouchedToInvalidFields()
    if (!this.form.valid) {
      this.unespCoreMessageService.showMessageError('O formulário não foi preenchido corretamente')
      return
    }
    let code = this.form.controls['codigo'].getRawValue()
    if (code) {
      this.recaptchaV3Service.execute('importantAction').subscribe((token: string) => {
        this.certificadoService.verificar(code!.toUpperCase()).subscribe(data => {
          let blob = new Blob([data], {
            type: 'application/pdf',
          })
          if (blob.size === 0) {
            this.unespCoreMessageService.showMessageError('Código verificador inválido')
          } else {
            let url = window.URL.createObjectURL(blob)
            this.dialog.open(PdfViewerComponent, {
              data: {
                titulo: `Certificado`,
                url: url,
              },
              width: '80%',
              height: '90%',
            })
          }
        })
      })
    }
  }
}
